import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "",
  style: {"background-color":"rgba(250, 250, 250, 1) !important"}
}
const _hoisted_2 = { class: "p-2 m-1" }
const _hoisted_3 = {
  class: "accordion",
  id: "accordionExample"
}
const _hoisted_4 = ["onKey"]
const _hoisted_5 = { class: "accordion-header" }
const _hoisted_6 = ["data-bs-target", "aria-controls"]
const _hoisted_7 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (e, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "accordion-item",
          onKey: index
        }, [
          _createElementVNode("h2", _hoisted_5, [
            _createElementVNode("button", {
              class: "accordion-button",
              type: "button",
              "data-bs-toggle": "collapse",
              "data-bs-target": `#index` +index,
              "aria-expanded": "false",
              "aria-controls": `index`+index
            }, _toDisplayString(e.title), 9, _hoisted_6)
          ]),
          _createElementVNode("div", {
            id: `index`+index,
            class: "accordion-collapse collapse",
            "data-bs-parent": "#accordionExample"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(e.descriptions, (d, index2) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "accordion-body",
                key: index2
              }, _toDisplayString(d.description), 1))
            }), 128))
          ], 8, _hoisted_7)
        ], 40, _hoisted_4))
      }), 128))
    ])
  ]))
}